var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{covered: _vm.covered},on:{"click":function($event){return _vm.handleClick(_vm.index)}}},[_c('img',{attrs:{"src":require(("../assets/" + _vm.animal + ".png"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }